<template>
  <div>
    <div id="myGraph" style="height: 100%"></div>
    <div v-if="suggestions.length === 0" style="height: 100%;width: 100%;position: absolute; top: 0">
      <div class="text-center" style="margin-top: 150px">No suggestions</div>
    </div>
  </div>
</template>

<style>
  @import '../../assets/css/gojs/FoamTreeContextMenu.css';
  .popover-wiki-search {
    min-width: 240px;
    max-width: 350px;
    color: #3c3c3c;
  }

  .popover-wiki-search .popover-content .searchmatch {
    font-weight: bold;
  }

  .popover-wiki-search .popover-content ul {
    padding: 5px;
    list-style-type: none;
  }

  .popover-wiki-article {
    min-width: 500px;
    max-width: 700px;
    color: #3c3c3c;

  }

  .popover-wiki-article .wiki-thumbnail {
    float: right;
    height: 170px;
  }

  .popover-wiki-article .wiki-highlight {
    font-weight: bold;
  }

  .foamTreeContextMenu .foamTree-title {
    padding: 8px 14px;
    margin: 0;
    font-size: 14px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    border-radius: 5px 5px 0 0;
  }
  .foamTreeContextMenu .foamTree-content {
    padding: 9px 14px;
  }

  .foamTree-content li:hover {
    color: #3498db;
    cursor: pointer;
  }

  .foamTreeContextMenu {
    position: absolute;
    padding: 1px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    line-break: auto;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    font-size: 14px;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  }

</style>
<script>
import {Tooltip} from 'tau-tooltip'
import {hashCode} from '../../assets/scripts/utils'
import {foamtree} from '../../assets/scripts/visualization/carrotsearch.foamtree.js'

export default {
  components: {},
  name: 'FoamTreeSimpleSuggestionsBox',
  props: ['suggestions', 'showLimitPlan', 'height', 'biblio'],
  data: function () {
    return {
      faom: null,
      contextMenuOption: {
        baseClass: 'foamTreeContextMenu', // Base tooltip class name.
        typeClass: null, // Type tooltip class name.
        effectClass: null, // Effect tooltip class name.
        inClass: 'in', // Class used to transition stuff in.
        place: 'top', // Default place.
        spacing: null, // Gap between target and tooltip.
        auto: 0 // Whether to automatically adjust place to fit into window.
      },
      contextWikiOption: {
        baseClass: 'foamTreeContextMenu', // Base tooltip class name.
        typeClass: null, // Type tooltip class name.
        effectClass: null, // Effect tooltip class name.
        inClass: 'in', // Class used to transition stuff in.
        place: 'right', // Default place.
        spacing: null, // Gap between target and tooltip.
        auto: 0 // Whether to automatically adjust place to fit into window.
      },
      wikiArticles: {},
      localSuggestions: [],
      urlWiki: null,
      urlDbPedia: null
    }
  },
  mounted: function () {
    this.initWikipedia()
  },
  watch: {
    value: function (suggestions) {
      this.localSuggestions = []
      this.initWikipedia()
    },
    localSuggestions: function (localSuggestions) {
      if (typeof localSuggestions !== 'undefined' && localSuggestions !== null && localSuggestions.length === 1) {
        this.$eventHub.$emit('onShowSuggestion', true)
      }
    }
  },
  methods: {
    init: function () {
      let parentWidth = $('#myGraph').parent().width()
      document.getElementById('myGraph').style.width = parentWidth + 'px'
      document.getElementById('myGraph').style.height = this.height + 'px'
      let contextmenu = this.tooltipMenu()
      let contextWiki = this.tooltipWiki()
      this.faom = new CarrotSearchFoamTree({
        id: 'myGraph',
        rainbowStartColor: 'hsla(204, 70%, 53%, 1)',
        rainbowEndColor: 'hsla(204, 70%, 53%, 1)',
        pixelRatio: window.devicePixelRatio || 1,
        onGroupDrag: function (e) {
          // Prevent dragging only on touch devices
          if (('ontouchstart' in window)) {
            e.allowOriginalEventDefault()
            e.preventDefault()
          }
        },
        onGroupClick: (event) => {
          contextmenu.hide()
          contextWiki.hide()
          if (!event.group) {
            contextmenu.setGroup(null)
          } else {
            // Hide the context menu on any click
            contextmenu.setGroup(event.group)

            if (event.secondary === true) {
              // Show the menu only on right-click
              contextmenu.show()
            } else if (event.type === 'click') {
              this.refineSearch(event.group.label)
            }
          }
        },
        onGroupHover: function (event) {
          if (!event.group) {
            contextWiki.setGroup(null)

            contextmenu.hide()
            contextWiki.hide()
          } else {
            if (contextWiki.getGroup() !== event.group) {
              contextmenu.hide()
              contextWiki.setGroup(event.group)
              setTimeout(() => {
                contextWiki.show()
              }, 300)
            }
          }
          // Tell the tooltip which group is currently hovered on
          // contextmenu.group(event.group)
        },
        // Hide the context menu on zoom, open/close and expose
        onGroupMouseWheel: function (e) {
          e.allowOriginalEventDefault()
          e.preventDefault()
          contextmenu.hide()
          contextWiki.hide()
        },
        onGroupExposureChanging: function () {
          contextmenu.hide()
          contextWiki.hide()
        },
        onGroupOpenOrCloseChanging: function () {
          contextWiki.hide()
          contextmenu.hide()
        },
        maxLabelSizeForTitleBar: '10', // Number.MAX_VALUE,
        titleBarTextColor: 'rgba(255, 255, 255, 1)',
        titleBarDecorator: function (options, parameters, variables) {
          variables.titleBarText = 'Right click for menu options'
        },
        rolloutDuration: 6000,
        dataObject: {
          groups: this.parseDatas(this.suggestions)
        }
      })
    },
    parseDatas: function (kwds) {
      let kwDatas = []
      if (kwds) {
        kwds.forEach((kwd) => {
          kwDatas.push({label: kwd.name, weight: kwd.score})
        })
      }
      return kwDatas
    },
    tooltipMenu: function () {
      // A simple utility for tracking mouse position and showing/hiding the context menu.
      // var Tooltip = require('tooltip')
      let tip = new Tooltip('contextmenu', this.contextMenuOption)
      let pageX, pageY
      let currentGroup
      let self = this

      function hide () {
        tip.hide()
      }

      function show () {
        if (currentGroup && currentGroup.label) {
          let key

          if (self.localSuggestions && self.localSuggestions.length > 1) {
            self.localSuggestions.forEach((suggestion) => {
              if (currentGroup.label === suggestion.name) {
                key = suggestion
              }
            })
          }

          // Set some example content on the context menu.
          let content = "<div class='foamTree-title' ><strong>" + currentGroup.label + '</strong></div>' +
              "<div class='foamTree-content'>" +
              "<div class='option foamtree-option' data-action='refineSearch'><i class='pe-7s-search pe-fw'></i> Refine current search</div>" +
              "<div class='option foamtree-option' data-action='searchOnlySuggestion' ><i  class='pe-7s-search pe-fw'></i> Search only with this suggestion</div>"
          if (self.$user.isBasic()) {
            content += "<div class='option-disabled foamtree-option' data-action='addToBiblio' title='Subscribe to advanced Account'> <i class='pe-7s-plus pe-fw'></i> Save suggestion <i class='fa fa-lock font-bold'></i></div>"
          } else {
            content += "<div class='option-disabled foamtree-option' data-action='addToBiblio' title='Subscribe to advanced Account'> <i class='pe-7s-plus pe-fw'></i> Save suggestion</div>"
          }
          content += '</div>'

          tip.content(content)
          tip.position(pageX, pageY)
          tip.show()
          $('.foamtree-option').on('click', (e) => {
            let suggestion = currentGroup.label
            let selectedOption = e.target.dataset.action

            if (suggestion) {
              switch (selectedOption) {
                case 'refineSearch':
                  self.refineSearch(suggestion)
                  break
                case 'searchOnlySuggestion':
                  self.onlySearch(suggestion)
                  break
                case 'addToBiblio':
                  self.addToBiblio(suggestion)
                  break
                default:
                  self.$notify({
                    type: 'error',
                    title: 'An error occurred during the last operation! Please try again or refresh the current page.',
                    placement: 'bottom-right'
                  })
              }
            }
          })
        }
      }

      function setGroup (g) {
        currentGroup = g
      }

      function getGroup () {
        return currentGroup
      }

      // Register a mouse move listener that will remember the coordinates of the mouse pointer
      document.body.addEventListener('mousemove', function (e) {
        pageX = e.pageX
        pageY = e.pageY
      })

      // Hide the context menu when it's clicked
      tip.element.addEventListener('click', function (e) {
        if (!e.target.href) {
          tip.hide()
          e.preventDefault()
        }
      })

      return {
        setGroup: setGroup,
        getGroup: getGroup,
        show: show,
        hide: hide
      }
    },
    tooltipWiki: function () {
      // A simple utility for tracking mouse position and showing/hiding the context menu.
      // var Tooltip = require('tooltip')
      let tip = new Tooltip('contextmenu2', this.contextWikiOption)
      let pageX, pageY
      let currentGroup
      let self = this

      function hide () {
        tip.hide()
      }

      function show () {
        if (currentGroup && currentGroup.label) {
          let kyw = ''
          if (self.localSuggestions && self.localSuggestions.length > 1) {
            self.localSuggestions.forEach((suggestion) => {
              if (currentGroup.label === suggestion.name) {
                kyw = suggestion
              }
            })
          }

          if (typeof kyw.popover !== 'undefined') {
            let popoverClass
            if (kyw.popover.title === 'Related Wikipedia articles') {
              popoverClass = 'popover-wiki-search'
            } else {
              popoverClass = 'popover-wiki-article'
            }

            // Set some example content on the context menu.
            tip.content('<div><div class="foamTree-title">' + kyw.popover.title + '</div><div class="foamTree-content"><div class="' + popoverClass + '">' + kyw.popover.content + '</div></div></div>')
            tip.position(pageX, pageY)
            tip.show()
            // open first wiki popover after 1 sec
            if (currentGroup && currentGroup.label) {
              self.initPopover(self.suggestionId(currentGroup.label))
            }
          }
        }
      }

      function setGroup (g) {
        currentGroup = g
      }

      function getGroup () {
        return currentGroup
      }

      // Register a mouse move listener that will remember the coordinates of the mouse pointer
      document.body.addEventListener('mousemove', function (e) {
        pageX = e.pageX
        pageY = e.pageY
      })

      return {
        setGroup: setGroup,
        getGroup: getGroup,
        show: show,
        hide: hide
      }
    },
    draw: function () {
      if (this.faom !== null) {
        this.faom.redraw()
      } else {
        this.init()
      }
    },
    refineSearch: function (suggestion) {
      this.$eventHub.$emit('refineWithSuggestion', this.suggestionName(suggestion))
    },
    addToBiblio: function (suggestion) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('saveSuggestion')
      } else if (typeof this.biblio !== 'undefined' && this.biblio !== null) {
        this.$requestStack.add('post', '/biblio/' + this.biblio.id + '/add/suggestion', {
          url: this.getCurrentUrlWithSuggestion(suggestion),
          title: suggestion
        }, 0).then((response) => {
          this.$notify({
            type: 'success',
            title: 'Suggestion added !',
            placement: 'bottom-right'
          })
          this.$eventHub.$emit('refreshBiblio', true)
        })
      }
    },
    addWikiArticleToBiblio: function (wiki) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('saveSuggestion')
      } else if (typeof this.biblio !== 'undefined' && this.biblio !== null) {
        this.$requestStack.add('post', '/biblio/' + this.biblio.id + '/add/wikiArticle', wiki, 0)
          .then((response) => {
            this.$notify({
              type: 'success',
              title: 'Article added !',
              placement: 'bottom-right'
            })
            this.$eventHub.$emit('refreshBiblio', true)
          })
      }
    },
    onlySearch: function (suggestion) {
      this.$eventHub.$emit('onlySearchSuggestion', this.suggestionName(suggestion))
    },
    suggestionName: function (str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },
    getNbResultSuggestion: function (suggestion) {
      return this.$requestStack.add('get', '/search/' + this.query + '/suggestion/' + suggestion.name, null, 2)
    },
    getCurrentUrlWithSuggestion: function (suggestion) {
      let url = this.$router.currentRoute.fullPath
      let captured = /usedByCs=([^&]+)/.exec(url)
      suggestion = encodeURIComponent(suggestion)
      suggestion = captured ? captured[1] + ',' + suggestion : suggestion
      if (captured) {
        return url.replace(('usedByCs=' + captured[1]), 'usedByCs=' + suggestion)
      } else {
        return (url.match(/\?/)) ? url + '&usedByCs=' + suggestion : url + '?usedByCs=' + suggestion
      }
    },
    suggestionId: function (suggestion) {
      return hashCode(suggestion)
    },
    initWikipedia: function () {
      let keywords = []

      let kwToId = {}
      this.suggestions.forEach((suggestion) => {
        keywords.push(suggestion.name.toLowerCase())
        kwToId[suggestion.name] = hashCode(suggestion.name)
      })

      if (keywords.length !== 0) {
        $.ajax({
          dataType: 'json',
          url: this.urlWiki + '?origin=*&redirects=&action=query&format=json&titles=' + keywords.join('|'),
          cache: true
        }).then((data) => {
          let normalized = {}
          if (data.query.normalized.length !== 0) {
            data.query.normalized.forEach((val) => {
              normalized[val.to] = val.from
            })
          }

          // Load the redirects dictionary from the response data
          let redirects = {}
          if (typeof data.query.redirects !== 'undefined' && data.query.redirects.length !== 0) {
            data.query.redirects.forEach((val) => {
              redirects[val.to] = val.from
            })
          }

          Object.keys(data.query.pages).forEach((val) => {
            let page = data.query.pages[val]
            // Rebuild the original keyword
            let keyword = page.title
            if (redirects[keyword]) {
              keyword = redirects[keyword]
            }
            if (normalized[keyword]) {
              keyword = normalized[keyword]
            }
            keyword = keyword.toUpperCase()
            let id = kwToId[keyword]

            let pageid = page.pageid
            let type = (typeof pageid === 'undefined') ? 'search' : 'page'

            this.wikiArticles[id] = {'pageid': pageid, content: '', title: page.title, 'type': type, search: {}}
          })

          Promise.all([this.getWikipediaArticles(), this.searchWikiForRelated()]).then(() => {
            this.suggestions.forEach((suggestion, key) => {
              let id = hashCode(suggestion.name)
              let article = this.wikiArticles[id]
              suggestion.show = false
              suggestion.nbResults = '0'
              if (typeof article !== 'undefined') {
                this.wikiPopover(suggestion, article)
                suggestion.show = true
              }
              this.localSuggestions.push(suggestion)
              return suggestion
            })
          })
        })
      }
    },
    getWikipediaArticles: function () {
      return new Promise((resolve, reject) => {
        let pageidTolabelId = {}

        Object.keys(this.wikiArticles).forEach((id) => {
          let article = this.wikiArticles[id]

          if (typeof article.pageid !== 'undefined') {
            pageidTolabelId[article.pageid] = id
          }
        })

        if (Object.keys(pageidTolabelId).length !== 0) {
          this.dbPedia('id', Object.keys(pageidTolabelId)).then((response) => {
            if (typeof response.results.bindings !== 'undefined') {
              this.addNewArticles(response.results.bindings)
            }
            resolve(null)
          }).catch((error) => {
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    addNewArticles: function (bindings) {
      if (bindings) {
        let pageidTolabelId = {}
        Object.keys(this.wikiArticles).forEach((id) => {
          let article = this.wikiArticles[id]

          if (typeof article.pageid !== 'undefined') {
            pageidTolabelId[article.pageid] = id
          }
        })

        bindings.forEach((resource, index) => {
          let abstract = resource.abstract.value
          let thumbnail = null
          if (resource.thumbnail) {
            thumbnail = resource.thumbnail.value
          }

          let id = pageidTolabelId[parseInt(resource.pageid.value)]
          let article = this.wikiArticles[id]
          article.content = this.wikiArticlePopoverContent(abstract, article.title, thumbnail)
        })
      }
    },
    searchWikiForRelated: function () {
      let promises = []
      let articles = []

      return new Promise((resolve, reject) => {
        Object.keys(this.wikiArticles).forEach((id) => {
          let article = this.wikiArticles[id]

          if (article.type === 'search') {
            let data = {
              action: 'query',
              list: 'search',
              srsearch: article.title,
              srprop: 'titlesnippet',
              format: 'json'
            }

            let dataStr = Object.keys(data).map((key) => {
              return key + '=' + data[key]
            }).join('&')

            articles.push({article: article, id: id})

            promises.push($.ajax({
              dataType: 'json',
              url: this.urlWiki + '?origin=*&' + dataStr,
              cache: true
            }))
          }
        })

        this.axios.all(promises)
          .then(this.axios.spread((...args) => {
            for (let i = 0; i < args.length; i++) {
              let data = args[i]
              let article = articles[i].article
              let results = []

              if (typeof data.query !== 'undefined' && typeof data.query.search !== 'undefined' && data.query.search.length) {
                data.query.search.forEach((val, index) => {
                  results.push({'snippet': val.titlesnippet, 'title': val.title, 'pageid': val.pageid})
                })

                let id = articles[i].id

                article.content = this.wikiSearchPopoverContent(results, id)
              }
            }
            resolve(null)
          }))
      })
    },
    dbPedia: function (type, elements) {
      return new Promise((resolve, reject) => {
        let queryTemplate
        let filter

        if (elements.length !== 0) {
          switch (type) {
            case 'id':
              queryTemplate = 'PREFIX dbpedia-owl: <http://dbpedia.org/ontology/> select ?pageid ?abstract ?thumbnail where {?resource dbpedia-owl:wikiPageID ?pageid ; dbpedia-owl:abstract ?abstract . OPTIONAL { ?resource dbpedia-owl:thumbnail ?thumbnail } FILTER( ?pageid = %FILTER% ) filter(langMatches(lang(?abstract),"en"))}'
              filter = elements.join(' || ?pageid = ')
              break
            case 'title':
              elements.forEach((val, index) => {
                elements[index] = val.split(' ').join('_')
              })
              queryTemplate = 'PREFIX dbpedia-owl: <http://dbpedia.org/ontology/> PREFIX rdfs:  <http://www.w3.org/2000/01/rdf-schema#> select ?label ?abstract ?thumbnail where {?resource rdfs:label ?label ; dbpedia-owl:abstract ?abstract . OPTIONAL { ?resource dbpedia-owl:thumbnail ?thumbnail } FILTER( ?resource = <http://dbpedia.org/resource/%FILTER%> ) filter(langMatches(lang(?abstract),"en")) filter(langMatches(lang(?label),"en"))}'
              filter = elements.join('> || ?resource = <http://dbpedia.org/resource/')
              break
          }

          let data = {
            'default-graph-uri': 'http://dbpedia.org',
            query: queryTemplate.replace('%FILTER%', filter),
            format: 'application/json',
            timeout: 10
          }

          let dataStr = Object.keys(data).map((key) => {
            return key + '=' + data[key]
          }).join('&')

          $.ajax({
            dataType: 'json',
            url: this.urlDbPedia + '?' + dataStr,
            cache: true
          }).then((response) => {
            resolve(response)
          })
            .catch((error) => {
              reject(error)
            })
        } else {
          resolve([])
        }
      })
    },
    wikiArticlePopoverContent: function (abstract, title, thumbnail) {
      // Truncate the abstract if it's too long
      let maxlength = 1000
      if (abstract.length > maxlength) {
        // A regex is used to truncate at the end of a sentence.
        let pattern = '^.{0,' + maxlength + '}[\\.]'
        let regEx = new RegExp(pattern, 'gi')
        let re = abstract.match(regEx)
        abstract = re !== null ? re[0] + ' (&hellip;)' : abstract
      }

      // Highlight the title of the article in the abstract
      let template = '<span class="wiki-highlight">%s</span>'
      let pattern = '(' + title.split(' ').join(' |') + ')+'
      let titleRegEx = new RegExp(pattern, 'i')
      abstract = abstract.replace(titleRegEx, function (matched) {
        let r = template.replace('%s', matched)
        return r
      })
      abstract = '<span>' + abstract + '</span>'

      // Add the thumbnail
      if (thumbnail !== null && thumbnail.length) {
        abstract = '<img class="wiki-thumbnail" height="170" src="' + thumbnail.replace('http:', 'https:') + '">' + abstract
      }

      return '<div class="clearfix">' + abstract + '</div>'
    },
    wikiSearchPopoverContent: function (searchResults, parentId) {
      let content = $('<ul class="data-parent-id-' + parentId + '">')
      searchResults.forEach((val, index) => {
        let title = val.title
        let id = hashCode(title)
        let searchSnippet = $('<li class="data-page-wiki-id-' + val.pageid + '"></li>').addClass('wiki-search-result').addClass('fixed')
        searchSnippet.attr('id', id)
        if (typeof val.snippet !== 'undefined' && val.snippet.length) {
          searchSnippet.html(val.snippet)
        } else {
          searchSnippet.html(title)
        }
        content.append(searchSnippet.clone())
      })
      return $('<div>').append(content.clone()).html()
    },
    wikiPopover: function (suggestion, article, selector) {
      let popoverContent = article.content.replace('http:', 'https:')
      if (popoverContent.length) {
        let wikiURL = 'https://en.wikipedia.org/wiki/' + encodeURIComponent(article.title)
        let popoverTitle
        let popoverClass
        if (article.type === 'page') {
          let wikiLinkText = 'View full article'
          popoverTitle = '<div class="row">' +
              '<div class="col-xs-4 text-left"><a href="' + wikiURL + '" target="_blank" class="btn btn-info btn-outline wiki-article-link">' + wikiLinkText + '</a></div>' +
              '<div class="col-xs-4 text-center m-t-sm">Wikipedia article</div>'
          if (this.$user.isBasic()) {
            popoverTitle += '<div class="col-xs-4 text-right"><a class="saveToBiblio btn btn-info">Save to Biblio <i class="fa fa-lock font-bold"></i></a>'
          } else {
            popoverTitle += '<div class="col-xs-4 text-right"><a class="saveToBiblio btn btn-info" data-keyword="' + article.title + '" data-url="' + wikiURL + '">Save to Biblio</a>'
          }
          popoverTitle += '<div class="hidden" id="wiki-url">' + wikiURL + '</div>' +
            '<div class="hidden" id="article-title">' + article.title + '</div>' +
            '<div class="hidden" id="article-content">' + popoverContent + '</div>' +
            '</div>' +
            '</div>'

          popoverClass = 'popover-wiki-article'
        } else if (article.type === 'search') {
          popoverTitle = 'Related Wikipedia articles'
          popoverClass = 'popover-wiki-search'
        }

        let template = '<div class="popover ' + popoverClass + '">' +
            '<div class="arrow"></div>' +
            '<div class="popover-title"></div>' +
            '<div class="popover-content"></div>' +
            '</div>'
        if (suggestion !== null) {
          suggestion.popover = {
            template: template,
            title: popoverTitle,
            content: popoverContent
          }
        } else {
          $(selector).popover({
            template: template,
            trigger: 'hover',
            placement: 'right',
            content: popoverContent,
            html: true,
            title: popoverTitle,
            container: $(selector)
          })
        }

        $(document).off('click', '.saveToBiblio')
        $(document).on('click', '.saveToBiblio', (e) => {
          let wikiTitle = null
          let wikiUrl = null
          let wikiDefinitionContent = null

          $(e.target)[0].parentElement.childNodes.forEach((element) => {
            let id = element.id
            let innerText = element.innerText

            if (id === 'wiki-url') {
              wikiUrl = innerText
            } else if (id === 'article-title') {
              wikiTitle = innerText
            } else if (id === 'article-content') {
              wikiDefinitionContent = innerText
            }
          })
          let wiki = {'title': wikiTitle, 'url': wikiUrl, 'description': wikiDefinitionContent}

          this.addWikiArticleToBiblio(wiki)
          e.preventDefault()
        })
        $(document).off('click', '.wiki-article-link')
        $(document).on('click', '.wiki-article-link', (e) => {
          let link = e.target.href
          let win = window.open(link, '_blank')
          win.focus()
          e.preventDefault()
        })
      }
    },
    initPopover: function (id) {
      let pagesId = []

      $('.data-parent-id-' + id).children().each((index, wikiSuggestion) => {
        let title = $(wikiSuggestion).text()
        let id = hashCode(title)

        let regex1 = /data-page-wiki-id-(-*\d+)/
        let result = regex1.exec($(wikiSuggestion).attr('class'))

        let pageid = result[1]

        if (typeof this.wikiArticles[id] === 'undefined') {
          this.wikiArticles[id] = {'pageid': pageid, content: '', title: title, type: 'page', search: {}}
          pagesId.push(pageid)
        } else {
          let article = this.wikiArticles[id]
          this.wikiPopover(null, article, $('.data-page-wiki-id-' + article.pageid))
        }
      })

      this.dbPedia('id', pagesId).then((response) => {
        if (typeof response.results.bindings !== 'undefined') {
          this.addNewArticles(response.results.bindings)

          pagesId.forEach((pageId) => {
            let articleId = Object.keys(this.wikiArticles).find((id) => {
              return this.wikiArticles[id].pageid === pageId.toString()
            })
            let article = this.wikiArticles[articleId]

            this.wikiPopover(null, article, $('.data-page-wiki-id-' + article.pageid))
          })
        }
      }).catch((error) => {
      })
    }
  },
  beforeMount () {
    this.urlWiki = 'https://en.wikipedia.org/w/api.php'
    this.urlDbPedia = 'https://dbpedia.org/sparql'
  },
  beforeDestroy () {
    $('.foamTreeContextMenu').hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/FoamTreeSimpleSuggestionsBox.vue